<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<article class="card-event card" [ngClass]="{ 'full-width': fullWidth }">
  <figure class="card-event__image" (click)="goToEventPage()">
    @if (isProducerArea) {
      <span
        class="card-event__status card-event__status--{{
          eventDateHasPassed(event.end_date) ? 'finished' : event.status
        }}"
        >{{ getEventStatus() }}</span
      >
    } @else {
      <div class="card-event__favorite" [class.card-event__favorite--finished]="eventDateHasPassed(event.end_date)">
        <button mat-icon-button (click)="handleFavoriteClick($event)">
          <mat-icon [class.animate-pulse]="isAnimating">{{
            event.is_favorite ? "favorite" : "favorite_border"
          }}</mat-icon>
        </button>
      </div>
    }
    <img
      [src]="eventImage"
      appImgFallback="./../../../../assets/images/evento-sem-imagem.svg"
      alt="Banner do evento"
      [class.card-event__image--finished]="eventDateHasPassed(event.end_date)" />
  </figure>

  <section class="card-event__content">
    <time [dateTime]="event.start_date">
      {{ event.start_date | date: "dd/MM/yy" }} - {{ event.start_date | date: "shortTime" }}
    </time>
    <h2 [title]="event.title + ' - Ir para o evento'" (click)="goToEventPage()" class="card-event__title">
      {{ event.title }}
    </h2>
    <address class="p-0">
      @if (event.address; as location) {
        <p class="p m-0">{{ location.location_name }}</p>
        <p class="text-secondary m-0">{{ location.city_name }}</p>
      } @else if (event.online) {
        <p class="p m-0">Evento online</p>
      }
    </address>
    @if (event.event_category?.title) {
      <span class="card-event__category">{{ event.event_category.title }}</span>
    }
    @if (isProducerArea) {
      <!-- TODO: uncommend this code after backend implements this data -->
      <!-- <div class="card-event__details">
        <p>VENDIDOS: <span>XX</span></p>
        <p>QUANTIDADE: <span>XXXX</span></p>
      </div> -->
    }
  </section>
  @if (isProducerArea && showEditButton) {
    <section class="card-event__buttons">
      <app-button
        [disabled]="eventDateHasPassed(event.end_date)"
        style="width: 100%"
        (btnClick)="editEvent()"
        icon="pi pi-pencil"
        >Editar evento</app-button
      >
    </section>
  }
</article>
